export interface Ready {
  kind: 'ready';
}

export interface Saving {
  kind: 'saving';
}

export interface Publishing {
  kind: 'publishing';
}

export interface ConfirmingPublish {
  kind: 'confirming-publish';
}

export interface ConfirmingCreate {
  kind: 'confirming-create';
}

export interface ConfirmingCancel {
  kind: 'confirming-cancel';
}

export interface SaveError {
  kind: 'error';
  error: Error;
}

export type SaveActionsState =
  | Ready
  | Saving
  | Publishing
  | ConfirmingPublish
  | ConfirmingCreate
  | ConfirmingCancel
  | SaveError;

export const ready = (): Ready => ({
  kind: 'ready',
});

export const saving = (): Saving => ({
  kind: 'saving',
});

export const publishing = (): Publishing => ({
  kind: 'publishing',
});

export const confirmingPublish = (): ConfirmingPublish => ({
  kind: 'confirming-publish',
});

export const confirmingCreate = (): ConfirmingCreate => ({
  kind: 'confirming-create',
});

export const confirmingCancel = (): ConfirmingCancel => ({
  kind: 'confirming-cancel',
});

export const error = (err: Error): SaveError => ({
  kind: 'error',
  error: err,
});
